// extracted by mini-css-extract-plugin
export default {"contact":"Contact_contact__+aS9B","intro":"Contact_intro__ATx2H","rowGrid":"Contact_rowGrid__BIZ+0","coffee":"Contact_coffee__B83Z0"};